import dJSON from 'dirty-json';

import Splide from '@splidejs/splide';

const moduleSelector = '.testimonials-simple';

/**
 * Module Init
 */
(() => {
  const modules = document.querySelectorAll(moduleSelector);
  if (!modules.length) return;

  modules.forEach((query) => {
    try {
      query.querySelector('script')?.remove(); // cleanup

      const { data } = dJSON.parse(query.data);

      const generateStars = (count) => {
        const starSvg = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="-2 -1.45 29 27.9">   <path d="M11.6201 1.65283C11.9446 0.880777 13.0564 0.880725 13.3809 1.65283L13.3818 1.65479L16.1377 8.15869L16.2559 8.43701L16.5557 8.4624L23.5996 9.06006H23.6025C24.4406 9.12683 24.7899 10.1785 24.1465 10.7358H24.1455L18.7939 15.3735L18.5654 15.5708L18.6338 15.8647L20.2383 22.7485C20.4297 23.5737 19.5393 24.2222 18.8115 23.7817L12.7588 20.1216L12.501 19.9653L12.2422 20.1206L6.19043 23.7671H6.18945C5.46163 24.2076 4.57117 23.5591 4.7627 22.7339L6.36621 15.8501L6.43457 15.5562L6.20703 15.3589L0.854492 10.7212C0.210871 10.1638 0.560254 9.11208 1.39844 9.04541H1.40137L8.44434 8.44775L8.74512 8.42236L8.8623 8.14502L11.6191 1.65479L11.6201 1.65283Z" fill="#00b3ca" stroke="#00b3ca"></path> </svg>';
        return starSvg.repeat(count);
      };

      data.forEach((item) => {
        query.querySelector('.splide__list').insertAdjacentHTML('beforeend', /* html */ `
          <div class="splide__slide">
            <div class="testimonial">
              <div class="stars">
                ${generateStars(item.stars)}
              </div>
              <h2 class="title">${item.title || ''}</h2>
              <p class="text">${item.text || ''}</p>
              <p class="author">${item.author || ''}</p>
            </div>
          </div>
        `);
      });
    } catch (error) {
      console.error(`Error: ${moduleSelector}`, error);
    }
  });
})();

(() => {
  document.querySelectorAll('.testimonials-simple .splide').forEach((item) => {
    const slideCount = item.querySelectorAll('.splide__slide').length;

    const slider = new Splide(item, {
      type: 'slide',
      perPage: 1,
      perMove: 1,
      gap: 30,
      pagination: slideCount > 1,
      drag: slideCount > 1,
      arrows: false,
      autoplay: false,
    });
    slider.mount();
  });

  setTimeout(() => {
    window.dispatchEvent(new Event('resize'));
  }, 500);
})();
